function SubmittalsBigIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="174"
      height="79"
      viewBox="0 0 174 79"
      fill="none"
    >
      <path
        d="M76.5 30.75V25.5C76.5 24.5335 77.2835 23.75 78.25 23.75H89.4749L92.9749 27.25H102.75C103.717 27.25 104.5 28.0335 104.5 29V46.5C104.5 47.4665 103.717 48.25 102.75 48.25H97.5V53.5C97.5 54.4665 96.7165 55.25 95.75 55.25H71.25C70.2835 55.25 69.5 54.4665 69.5 53.5V32.5C69.5 31.5335 70.2835 30.75 71.25 30.75H76.5ZM76.5 34.25H73V51.75H94V48.25H76.5V34.25ZM80 27.25V44.75H101V30.75H91.5252L88.0252 27.25H80Z"
        fill="#8E8E8E"
        fillOpacity="0.8"
      />
    </svg>
  );
}

export default SubmittalsBigIcon;
